export const productList = {
  1: {
    index: 0,
    title: "口令红包",
    imgPath: require("./wd0.jpg")
  },
  2: {
    index: 3,
    title: "天猫精灵",
    imgPath: require("./wd3.jpg")
  },
  8: {
    index: 2,
    title: "恐龙蛋100个",
    imgPath: require("./wd2.jpg")
  },
  4: {
    index: 7,
    title: "JURLIQUE身体乳",
    imgPath: require("./wd7.jpg")
  },
  5: {
    index: 1,
    title: "冬日办公室毯子",
    imgPath: require("./wd1.jpg")
  },
  3: {
    index: 6,
    title: "恐龙蛋15个",
    imgPath: require("./wd6.jpg")
  },
  7: {
    index: 5,
    title: "国家地理台历",
    imgPath: require("./wd5.jpg")
  },
  6: {
    index: 4,
    title: "恐龙蛋50个",
    imgPath: require("./wd4.jpg")
  }
};
